// useLocationFormLogic.ts
import { useState, useEffect } from "react";

import { Business } from "0.Mine/3.Interfaces/business";

export interface LocationFormLogicProps {
  updateBusinessData: (data: Partial<Business>) => void;
  businessData: Partial<Business>;
}

export interface LocationFormLogicReturn {
  location: Partial<Business>;
  setField: (field: keyof Partial<Business>, value: string | boolean) => void;
}

export const useLocationFormLogic = ({
  updateBusinessData,
  businessData,
}: LocationFormLogicProps): LocationFormLogicReturn => {
  const initialState: Partial<Business> = {
    address: businessData.address || "",
    postalCode: businessData.postalCode || "",
    city: businessData.city || "",
    country: businessData.country || "",
    province: businessData.province || "",
    locationHidden: businessData.locationHidden || false,
    isFranchise: businessData.isFranchise || false,
  };

  const [location, setLocation] = useState<Partial<Business>>(initialState);

  // Update the central business data whenever the location state changes.
  useEffect(() => {
    updateBusinessData(location);
  }, [location, updateBusinessData]);

  const setField = (field: keyof Partial<Business>, value: string | boolean) => {
    setLocation((prev) => ({ ...prev, [field]: value }));
  };

  return { location, setField };
};
